import React from 'react';

import './NewsletterError.scss';

export const NewsletterError = ({ message }: { message: string }) => <div className="audit-email-popup-error-message">
	{message}
</div>;
